import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  AllMenuResponse,
  CheckHasMenuPrivilegeResponse,
  MenuPrivilegeResponse,
} from '../_models/menuModel';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  http = inject(HttpClient);
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  baseUrl = `${environment.apiUrl}${environment.menuSercvice}`;

  // Menu Service
  GetAllMenu() {
    return this.http.get<AllMenuResponse>(
      `${this.baseUrl}/all`,
      this.httpOptions
    );
  }

  GetMenuByRoleCode(roleCode: string) {
    return this.http.get<MenuPrivilegeResponse>(
      `${this.baseUrl}/role/${roleCode}`,
      this.httpOptions
    );
  }

  CheckMenuPrivilege(userCode: string, menuCode: string) {
    return this.http.post<CheckHasMenuPrivilegeResponse>(
      `${this.baseUrl}/check-has-menu-privilege`,
      {
        userCode,
        menuCode,
      },
      this.httpOptions
    );
  }
}
